import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetCustomerAssessmentsByCommandID(commandID) {
  const response = await $.soap({
    body: {
      GetCustomerAssessmentsByCommandID: {
        $xmlns: 'http://dla.mil/ems/bpm/assessment',
        CommandID: commandID
      }
    },
    blueprintArrays: ['GetCustomerAssessmentsByCommandIDResponse.CustomerAssessment'],

    blueprint: {
      assessments: [
        '$..CustomerAssessment',
        {
          id: '$..ID',
          type: '$..Type',
          internalAssessmentStatus: '$..InternalAssessmentStatus',
          externalAssessmentStatus: '$..ExternalAssessmentStatus',
          updatedOn: '$..UpdatedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.assessments;
}
